import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../style/home.css';
import axios from "axios";
import Swal from "sweetalert2";


class WithdrawMoney extends React.Component {

    constructor() {
        super();
        this.state = {
            subject: "",
            body:"",
            howto:"",
        }
    }

    
    componentDidMount() {


        var form = new FormData();
        form.append("session", localStorage.getItem("token"));
        form.append("mobile", localStorage.getItem("mobile"));

        axios
            .post(process.env.REACT_APP_URL+"/api2/get_complaint.php", form,
            )
            .then((response) => {
                if(response.status === 200){
                    if (response.data.nosession){
                        Swal.fire({
                            toast: true,
                            title: 'Oops...',
                            text: "Session Expired"
                        }).then((e)=>{
                            localStorage.clear()
                            window.location.href = "/login";
                        })
                    }
                    this.setState({
                        howto:response.data.data,
                    })
                } else if(response.status === 401){
                    //  navigate("/login")
                }
            })
    }


    render() {


      
        let apiCall = () =>{
            if( this.state.body == ""){
                Swal.fire({
                    toast: true,
                    title: 'Oops...',
                    text: "You must have to fill all details"
                })
            } else {
                var form = new FormData();
                form.append("session", localStorage.getItem("token"));
                form.append("mobile", localStorage.getItem("mobile"));
    
                form.append("subject", this.state.subject);
                form.append("body", this.state.body);
    
                axios
                    .post(process.env.REACT_APP_URL+`/api2/complaint.php`,form)
                    .then((response) => {
                        if (response.data.nosession){
                            Swal.fire({
                                toast: true,
                                title: 'Oops...',
                                text: "Session Expired"
                            }).then((e)=>{
                                localStorage.clear()
                                window.location.href = "/login";
                            })
                        }
                        if(response.data.success === "0"){
                            Swal.fire({
                                toast: true,
                                title: 'Oops...',
                                text: response.data.msg,
                            })
                        } else {
                            Swal.fire({
                                toast: true,
                                title: 'Complaint Submitted',
                                text: response.data.msg,
                            }).then((e)=>{
                                window.location.href = "/home";
                            })
                        }
                    })
    
            }

          
        }

        return (<>
                <div className="RootView">
                    <div className="RootWidth">

                        <div className="loginDiv">


                            <div className="toolbar">
                                <div>
                                    <img onClick={()=>{window.history.go(-1)}}  src="../images/back.png" style={{padding: "5px"}}/>
                                    <span>Report a Complaint</span>
                                </div>


                            </div>



                            <div style={{padding:"15px"}} className="withdraw-form">

                              
                             

                                <textarea
                                    style={{width:"100%", display:this.state.paytmView, marginTop:"15px"}}
                                    className="edittext"
                                    name="body"
                                    type="number"
                                    value={this.state.body}
                                    onChange={(e)=>{this.setState({body:e.target.value})}}
                                    placeholder="Enter Complaint"
                                />

                                <button className="button" onClick={apiCall}>
                                    <b>Submit</b>
                                </button>


                                <div style={{padding:"15px"}}>
                                <span className="contentSpan"><div dangerouslySetInnerHTML={{__html: this.state.howto}} className='editor'></div></span>
                            </div>
                             
                                
                            </div>

                        </div>


                    </div>
                </div>


            </>
        );
    }

}

export default WithdrawMoney;



